import React, { useState, useEffect } from "react";
import axios from "axios";

const Entitlement_Status = () => {
  const [entMonth, setEntMonth] = useState("");
  const [entYear, setEntYear] = useState("");
  const [masterData, setMasterData] = useState({ entitlements: [] });
  const [summaryData, setSummaryData] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [reportTitle, setReportTitle] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/entitlementreport/master-datareport`)
      .then((res) => setMasterData(res.data))
      .catch((error) => {
        console.error("Error fetching master data:", error);
        alert("Error fetching master data.");
      });
  }, []);

  const fetchSummaryRecords = () => {
    if (!entMonth) {
      alert("Please select Month.");
      return;
    }

    if (!entYear) {
      alert("Please select Year.");
      return;
    }

    const monthName = new Date(0, entMonth - 1).toLocaleString("default", {
      month: "long",
    });
    setReportTitle(`Entitlement Status for ${monthName} ${entYear}`);
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_URL}/api/entitlementreport/summary-recordsreport`, {
        params: { month: entMonth, year: entYear },
      })
      .then((res) => {
        const response = res.data;
        setLoading(false);

        if (
          response.status === "table_not_found" ||
          response.status === "no_data"
        ) {
          alert(response.message);
          setShowSummary(false);
          setSummaryData([]);
          return;
        }

        if (response.status === "success") {
          setSummaryData(response.data);
          setShowSummary(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching summary records:", error);
        alert("Error fetching summary records.");
        setLoading(false);
      });
  };

  const exportToExcel = () => {
    const table = document.getElementById("summaryTable");
    if (!table) return;

    const tableClone = table.cloneNode(true);

    tableClone.querySelectorAll("thead tr, thead th").forEach((el) => {
      el.setAttribute(
        "style",
        "background-color: white; color: black; font-weight: bold; text-align: center;"
      );
    });

    tableClone.querySelectorAll("td").forEach((td) => {
      td.setAttribute("style", 'mso-number-format:"\\@";');
    });

    const tableHTML = tableClone.outerHTML.replace(/(\r\n|\n|\r)/gm, "");

    const htmlContent = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
            xmlns:x="urn:schemas-microsoft-com:office:excel"
            xmlns="http://www.w3.org/TR/REC-html40">
      <head><meta charset="UTF-8"></head>
      <body>${tableHTML}</body>
      </html>`;

    const blob = new Blob([htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Entitlement_Status_Report_${entMonth}_${entYear}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      className="wrapper row3"
      style={{ maxHeight: "95vh", overflowY: "auto", paddingBottom: "40px" }}
    >
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
          <table width="50%">
            <thead>
              <tr className="tableheader">
                <th colSpan={4}>ENTITLEMENT GENERATION</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ent Month:</td>
                <td>
                  <select
                    value={entMonth}
                    onChange={(e) => setEntMonth(e.target.value)}
                    required
                  >
                    <option value="">--Select Month--</option>
                    {masterData.entitlements.map((it, i) => (
                      <option key={i} value={it.month}>
                        {new Date(0, it.month - 1).toLocaleString("default", {
                          month: "long",
                        })}
                      </option>
                    ))}
                  </select>
                </td>
                <td>Ent Year:</td>
                <td>
                  <select
                    value={entYear}
                    onChange={(e) => setEntYear(e.target.value)}
                    required
                  >
                    <option value="">--Select Year--</option>
                    {masterData.entitlements
                      .filter((it) => it.month === parseInt(entMonth))
                      .map((it, i) => (
                        <option key={i} value={it.year}>
                          {it.year}
                        </option>
                      ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <button type="button" onClick={fetchSummaryRecords} className="button button2">
            Submit
          </button>
        </div>

        {loading && (
          <div id="loading" style={{ textAlign: "center", marginTop: "10px" }}>
            <img src="https://epos.assam.gov.in/images/progress.gif" alt="Loading..." />
          </div>
        )}

        {showSummary && !loading && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <table
              id="summaryTable"
              width="90%"
              border="1"
              style={{ borderCollapse: "collapse", textAlign: "center" }}
            >
              <thead>
                <tr className="tableheader">
                  <th colSpan={6}>{reportTitle}</th>
                </tr>
                <tr style={{ backgroundColor: "black", color: "white" }}>
                  <th>Month</th>
                  <th>Year</th>
                  <th>District</th>
                  <th>Scheme</th>
                  <th>Commodity</th>
                  <th>Entitlement Status</th>
                </tr>
              </thead>
              <tbody>
                {summaryData.length > 0 ? (
                  summaryData.map((record, i) => (
                    <tr key={i}>
                      <td>
                        {record.month !== 0
                          ? new Date(0, record.month - 1).toLocaleString("default", {
                              month: "long",
                            })
                          : ""}
                      </td>
                      <td>{record.year !== 0 ? record.year : ""}</td>
                      <td>{record.districtName || "-"}</td>
                      <td>{record.schemeName || "-"}</td>
                      <td>{record.commName || "-"}</td>
                      <td
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "green",
                        }}
                      >
                        &#10004;
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}>No data found…</td>
                  </tr>
                )}
              </tbody>
            </table>

            <div style={{ marginTop: "20px" }}>
              <button onClick={exportToExcel} className="button button2">
                Download Excel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Entitlement_Status;
